import type { CommandCategory } from 'owa-hotkeys-map';
import {
    generalCommandCategory,
    canvasCommandCategory,
    linkCommandCategory,
    taskCommandCategory,
    messagesAndEventsCommandCategory,
    searchResultsCommandCategory,
} from './TimeStreamHotkeys.locstring.json';
import loc from 'owa-localize';

export const GeneralCategoryKey = 'general';
export const CanvasCategoryKey = 'canvas';
export const LinkCategoryKey = 'link';
export const TaskCategoryKey = 'task';
export const MessagesAndEventsCategoryKey = 'messagesAndEvents';
export const SearchResultsCategoryKey = 'searchResults';

export default function getTimeStreamHotkeyCategories(): CommandCategory[] {
    return [
        { category: GeneralCategoryKey, displayName: loc(generalCommandCategory) },
        { category: CanvasCategoryKey, displayName: loc(canvasCommandCategory) },
        { category: LinkCategoryKey, displayName: loc(linkCommandCategory) },
        { category: TaskCategoryKey, displayName: loc(taskCommandCategory) },
        {
            category: MessagesAndEventsCategoryKey,
            displayName: loc(messagesAndEventsCommandCategory),
        },
        { category: SearchResultsCategoryKey, displayName: loc(searchResultsCommandCategory) },
    ];
}
